export default __webpack_public_path__ + "static/media/popUp_1.dfab3df6.ogg";